<count-button class="number-count-button" (onClick)="onClickCountChangeByOne(true)" [disabled]="!canCountUp" [cssClass]="'fa fa-arrow-up fa-2x'"></count-button>
<span class="number-label">{{ value }}</span>
<count-button class="number-count-button" (onClick)="onClickCountChangeByOne(false)" [disabled]="!canCountDown"
  [cssClass]="'fa fa-arrow-down fa-2x'"></count-button>
